import Vue from 'vue';
import App from './App.vue';
import vSelect from 'vue-select'
import BootstrapVue from 'bootstrap-vue';
import router from './router/index';
import Breadcrumbs from './components/bread_crumbs';
import  store  from './store/index';
import VueFeather from 'vue-feather';
import VueSweetalert2 from 'vue-sweetalert2';

import VGeosearch from 'vue2-leaflet-geosearch';
import PxCard  from './components/Pxcard.vue';
Vue.component(PxCard.name, PxCard);
Vue.component('v-geosearch', VGeosearch);
// Import Theme scss
import './assets/scss/app.scss';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-search-select/dist/VueSearchSelect.css'
import './assets/css/main.css';

import moment from 'moment';
import axios from 'axios';
import VueAxios from 'vue-axios';
//touch
import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents)

Vue.use(VueAxios, axios);
Vue.prototype.moment = moment

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);
Vue.component('v-select', vSelect);
Vue.use(VueSweetalert2);

Vue.use(VueFeather);
Vue.use(BootstrapVue);
Vue.component('Breadcrumbs', Breadcrumbs);

axios.defaults.baseURL = process.env.VUE_APP_URL;

//interceptar las petiuciones y ver si tiene token
axios.interceptors.response.use((response) => {
  if(response.status == 401 || response.status == 403) {
    localStorage.removeItem('token');
    window.location.href = process.env.VUE_APP_BASE_URL;
  }
  return response;
}, (error) => {
  console.log(error);
  if(error.response.status == 401 || error.response.status == 403) {
    localStorage.removeItem('token');
    window.location.href = process.env.VUE_APP_BASE_URL;
  }
});

//envia token para todas las peticiones
axios.interceptors.request.use(
  config => {
      if (localStorage.getItem("token")) {       
          config.headers.token = localStorage.getItem("token");
      }
      return config;
  },
  function(err) {
      console.log("No hay token desde el interceptor" + err);
  }
);

// google mapa
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyD6DaznSGIiKHh-CTOBu9acbUqdwkD27Y8",//"AIzaSyCWAZ49IYfc8E01KK56LhDzfC_MnMGf9SU",
    libraries:['places'],
    version:'3'
  },
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');